import React, { useEffect, useState } from "react";
import { Button, Space, Modal, Upload, Typography, Col, Row } from "antd";
import { InboxOutlined, DeleteFilled } from "@ant-design/icons";
import { useAxios } from "../../hooks/useAxios";
import { useParams } from "react-router-dom";
import ViewIcon from "../../assets/svgs/view_icon.svg";
import PDFIcon from "../../assets/svgs/pdf-icon.svg";
import SearchInput from "../FormFields/SearchInput";
import useDeleteConfirm from "../../hooks/useDeleteConfirm";
import DataTable from "../Common/DataTable";
import { useNotification } from "../../contexts/NotificationProvider";
const { Dragger } = Upload;

const DepartmentTableView = () => {
  const { axiosInstance } = useAxios();
  const notify = useNotification();
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [departments, setDepartment] = useState([]);
  const [file, setFile] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleDownloadPDF = async (record) => {
    try {
      const response = await axiosInstance.get(
        `/api/rota/generate-pdf/${record.id}/`
      );
      window.open(response.data.pdf_url, "_blank");
    } catch (err) {
      notify({
        type: "error",
        message: "Failed to generate PDF",
      });
    }
  };
  const showBulkDeleteConfirm = useDeleteConfirm(async (selectedIds) => {
    setLoading(true);
    try {
      const payload = {
        ids: selectedIds?.length ? selectedIds : [],
      };
      await axiosInstance.delete(`/api/department/${id}/`, {
        data: payload,
      });
      notify({
        type: "success",
        message: selectedIds?.length
          ? `Deleted ${selectedIds.length} rotas`
          : "Deleted all rotas",
      });
      fetchdepartments();
    } catch (error) {
      notify({
        type: "error",
        message:
          error.response?.data?.message ||
          "Failed to delete selected rotas",
      });
    } finally {
      setLoading(false);
    }
  });

  const columns = [
    {
      title: "Employee ID",
      render: (data) => (
        <span>
          {data.employer}
          {data?.employee?.employee_code}
        </span>
      ), // Adjust to include avatars if needed
    },
    {
      title: "Full Name",
      render: (data) => (
        <span>
          {data?.employee?.last_name} {data?.employee?.first_name}
        </span>
      ), // Adjust to include avatars if needed
    },
    {
      title: "Week Commencing",
      dataIndex: "week_commencing",
      key: "week_commencing",
    },
    {
      title: "Departments",
      dataIndex: "department_name",
      key: "department_name",
    },
    {
      title: "Total Hours (Week)",
      render: (data) => <span>{data?.total_hours} HRS</span>, // Adjust to include avatars if needed
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Space size={12}>
          <Button
            icon={
              <img
                src={ViewIcon}
                alt="View Icon"
                style={{ width: 24, height: 24 }}
              />
            }
            onClick={() => handleDownloadPDF(record)}
            style={{
              border: "none",
              background: "none",
              padding: 0,
            }}
          />

          <Button
            icon={
              <img
                src={PDFIcon}
                alt="PDF Icon"
                style={{ width: 24, height: 24 }}
              />
            }
            onClick={() => handleDownloadPDF(record)}
            style={{
              border: "none",
              background: "none",
              padding: 0,
            }}
          />

          <Button
            icon={<DeleteFilled style={{ color: "red", fontSize: 24 }} />}
            onClick={() =>
              showBulkDeleteConfirm(
                [record.id],
                "This action will permanently delete the selected rota. Once deleted, this data cannot be recovered."
              )
            }
            style={{ border: "none", background: "none", padding: 0 }}
          />
        </Space>
      ),
    },

    // {
    //   title: "Remaining Hours (Week) ",
    //   dataIndex: "remainingHrs",
    //   key: "remainingHrs",
    // },
  ];

  const showModal = () => {
    setFile([]);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const fetchdepartments = async (searchTerm = "", page = 1) => {
    try {
      const params = { page }; // Always include week_id

      if (searchTerm) {
        params.search = searchTerm; // Only add search if it's not empty
      }

      const response = await axiosInstance.get(`/api/department/${id}/`, {
        params,
      });
      setDepartment(response.data);
    } catch (e) {
      console.log("Error fetching departments", e.message);
    }
  };
  const handleSearch = (value) => {
    setCurrentPage(1);
    setSearchTerm(value);
    fetchdepartments(value, 1);
  };
  useEffect(() => {
    fetchdepartments();
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    fetchdepartments(searchTerm, currentPage);
  }, [searchTerm, currentPage]);
  return (
    <>
      <Modal
        title="Upload CSV"
        open={isModalOpen}
        onCancel={handleCancel}
        wrapClassName="main-modal-class"
        footer={[
          <Button
            style={{
              backgroundColor: "transparent",
              color: "#324054",
              border: "none",
              borderRadius: "4px",
              padding: "0 16px",
              height: "40px",
              fontWeight: 600,
              width: "118px",
            }}
            variant="text"
            onClick={handleCancel}
          >
            Cancel
          </Button>,
          <Button
            style={{
              backgroundColor: file.length ? "#212180" : "#B0B0B0",
              color: file.length ? "#FFF" : "#8C8C8C",
              border: "none",
              borderRadius: "4px",
              padding: "0 16px",
              height: "40px",
              fontWeight: 600,
              width: "118px",
            }}
            variant="text"
            // onClick={handleUploadCSV}
            disabled={!file.length || loading}
            loading={loading}
          >
            Submit
          </Button>,
        ]}
        className="upload-csv-modal"
      >
        <Dragger
          disabled={file.length === 2}
          name="file"
          multiple={false}
          maxCount={1}
          accept=".csv, .xlsx"
          //   {...uploaderProps}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined fill="#000000" />
          </p>
          <p className="ant-upload-text">
            Upload CSV File here.
            <span
              style={{
                textDecoration: "underline",
                color: "#1677ff",
                cursor: "pointer",
              }}
            >
              Browse
            </span>
          </p>
        </Dragger>
        <div style={{ marginTop: "16px", textAlign: "center" }}>
          <Typography.Text>Download template file: </Typography.Text>
          <a
            href="/employee_rota_template.xlsx" // Place the sample file in the public folder
            download="employee_rota_template.xlsx"
            style={{
              color: "#1677ff",
              cursor: "pointer",
              textDecoration: "underline",
              marginLeft: "5px",
            }}
          >
            employee_rota_template.xlsx
          </a>
        </div>
      </Modal>
      <Row
        gutter={[16, 16]}
        align="middle"
        justify="space-between"
        style={{ marginBottom: 16 }}
      >
        <Col xs={24} sm={24} md={12} lg={6}>
          <SearchInput
            onSearch={handleSearch}
            placeholder="Search by name or id ..."
            style={{ width: "100%" }}
          />
        </Col>
        <Space style={{ flexWrap: "wrap", justifyContent: "flex-end" }}>
          {/* <Button
            style={{
              background: "#212180",
              color: "#fff",
              width: "190px",
              height: "40px",
              padding: "12px 15px",
              margin: "0 10px",
            }}
            onClick={showModal}
            icon={<UploadOutlined />}
          >
            Upload CSV
          </Button> */}
        </Space>
      </Row>
      <div style={{ background: "#ffffff", borderRadius: "6px" }}>
        <DataTable
          columns={columns}
          rows={departments?.results}
          currentPage={currentPage}
          setCurrentPage={(page) => {
            setCurrentPage(page);
          }}
          position="end"
          marginTop="16px"
          marginBottom="16px"
          pageSize={10}
          totalResults={departments?.count || 0}
          showSizeChanger={false}
          selectable={true}
          rowKey="id"
          onDeleteSelected={showBulkDeleteConfirm}
          deleteAllText="Delete All departments"
          deleteSelectedText="Delete Selected"
          entities="This action will permanently delete the selected rota. Once deleted, this data cannot be recovered."
        />
      </div>
    </>
  );
};

export default React.memo(DepartmentTableView);
